import { CouponsApi } from './couponsApi';
import { DiscountsApi } from './discountsApi';
const mapCouponToCommon = coupon => {
  var _coupon$displayData, _coupon$displayData2, _coupon$specification;
  return {
    id: coupon == null ? void 0 : coupon.id,
    isCoupon: true,
    name: coupon == null ? void 0 : coupon.specification.name,
    startTime: coupon == null ? void 0 : coupon.specification.startTime,
    expirationTime: coupon == null ? void 0 : coupon.specification.expirationTime,
    couponDiscountType: coupon == null ? void 0 : coupon.specification.type,
    code: coupon == null ? void 0 : coupon.specification.code,
    couponMetadata: {
      isDisplayData: !!(coupon != null && coupon.displayData),
      isProduct: !!(coupon != null && (_coupon$displayData = coupon.displayData) != null && _coupon$displayData.formattedPrice),
      name: coupon == null || (_coupon$displayData2 = coupon.displayData) == null ? void 0 : _coupon$displayData2.name,
      moneyOffAmount: coupon == null || (_coupon$specification = coupon.specification) == null ? void 0 : _coupon$specification.moneyOffAmount,
      buyXGetY: {
        ...(coupon == null ? void 0 : coupon.specification.buyXGetY)
      },
      fixedPriceAmount: coupon == null ? void 0 : coupon.specification.fixedPriceAmount,
      percentOffRate: coupon == null ? void 0 : coupon.specification.percentOffRate,
      couponToEdit: coupon && JSON.parse(JSON.stringify(coupon))
    }
  };
};
const mapDiscountToCommon = discount => ({
  id: discount == null ? void 0 : discount.id,
  isCoupon: false,
  name: discount == null ? void 0 : discount.name,
  startTime: Date.parse(discount == null ? void 0 : discount.activeTimeInfo.start),
  expirationTime: discount != null && discount.activeTimeInfo.end ? Date.parse(discount == null ? void 0 : discount.activeTimeInfo.end) : undefined,
  couponDiscountType: discount == null ? void 0 : discount.discounts.values[0].discountType,
  offer: discount == null ? void 0 : discount.offer
});
export const mapDataToCommonFormat = {
  coupons: data => mapCouponToCommon(data),
  discounts: data => mapDiscountToCommon(data)
};
export const CouponsDiscountApi = async (instance, httpClient, type, Apis) => {
  const apiCalls = {
    coupons: CouponsApi(instance, httpClient).getCoupons,
    discounts: DiscountsApi(instance, httpClient).queryDiscounts
  };
  // Apis is required for both getCoupons and queryDiscounts
  const dataArr = await apiCalls[type](Apis);
  const resData = dataArr.map(item => mapDataToCommonFormat[type](item));
  const response = {
    metadata: {
      count: resData.length
    },
    data: resData
  };
  console.log('>>>>> CouponsDiscountApi = ', response);
  return response;
};
//# sourceMappingURL=couponsDiscountApi.js.map